export default deviceTags => {
  const mappedDeviceTags = [];

  if (!deviceTags) return mappedDeviceTags;

  deviceTags.forEach(deviceTag => {
    if (
      mappedDeviceTags.find(tag => {
        return tag.value.toLowerCase() === deviceTag.value.toLowerCase();
      })
    ) {
      return;
    }

    mappedDeviceTags.push(deviceTag);
  });

  return mappedDeviceTags;
};
